<script setup>
import {ref, watch, defineProps, defineEmits} from "vue";
import useSharedData from "@/use/SharedData.js";
import axios from "axios";
import {useAddressStore} from "@/stores/Address";

const props = defineProps({
    value: [Number, Array],
    customerId: Number,
    readonly: Boolean,
    disabled: Boolean,
    autoSelect: Boolean,
    label: String,
    rules: Array,
    multiple: Boolean,
});

const emit = defineEmits(["input"]);

const {loading, inputColor, inputBackgroundColor} = useSharedData();
const addressStore = useAddressStore();

const address = ref(null);

function findAll() {
    loading.value = true;
    axios.get(`/addresses`, {params: {customerId: props.customerId}}).then(response => {
        addressStore.setAddresses(response.data);
        if (props.autoSelect)
            emit('input', response.data.find(adr => adr.type === 'PRINCIPAL')?.id);
    }).finally(() => {
        loading.value = false;
    });
}

function input(value) {
    emit('input', value)
}

watch(() => props.value, () => {
    address.value = props.value;
}, {immediate: true});

watch(() => props.customerId, () => {
    if (props.customerId)
        findAll();
}, {immediate: true});
</script>

<template>
    <div>
        <v-autocomplete
            v-model="address"
            :items="addressStore.addresses"
            item-value="id"
            item-text="location"
            outlined
            dense
            :label="label"
            :color="inputColor"
            :background-color="inputBackgroundColor"
            :readonly="readonly"
            :disabled="disabled"
            :multiple="multiple"
            :loading="loading"
            :clearable="!readonly"
            @input="input"
            :rules="rules"
            hide-details="auto"
        ></v-autocomplete>

        <input type="hidden">
    </div>
</template>